<script>
	export let node;
	export let selectedElement;
	$: selected = (selectedElement === node);

	function toggleSelect () {
        selectedElement=node;
    }

</script>


<style>

    span {
		margin: 0 0 0 1.5em;
	    white-space: nowrap;
	}

	.selected {
        background-color: #aaaaaa;
    }

</style>


<span class:selected={selected}
    on:click={()=> {toggleSelect();}}>
    <span>{node.label}</span>
</span>